module.exports = __webpack_public_path__ + "img/cloth_g1_pants_08.9754b2dd.svg";